import React, { useState } from 'react';

import { Card } from './Card';
import { HelpPanelView } from './HelpPanel.view';

export interface HelpPanelProps {
  header: string;
  onClose?: () => void;
  cards: Card[];
}

export const HelpPanel: React.FC<HelpPanelProps> = ({
  header,
  onClose,
  cards,
}: HelpPanelProps) => {
  const [openedIndex, setOpenedIndex] = useState(0);

  const onLinkOpen = (link: string) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  const onCollapse = () => {
    setOpenedIndex(-1);
  };

  const onExpand = (index: number) => {
    setOpenedIndex(index);
  };

  return (
    <HelpPanelView
      header={header}
      onClose={onClose}
      cards={cards}
      onLinkOpen={onLinkOpen}
      onCollapse={onCollapse}
      onExpand={onExpand}
      openedIndex={openedIndex}
    />
  );
};
